var map = {
	"./acorns-platform/content.md": "0bb7",
	"./acorns-projects/content.md": "9651",
	"./acorns-tools/content.md": "91d4",
	"./centralized-data/content.md": "53df",
	"./data-access/content.md": "ddaf",
	"./data-qc/content.md": "2579",
	"./data-reports/content.md": "f8ae",
	"./data-science-workshops/content.md": "bdf1",
	"./dataset-tool/content.md": "a868",
	"./document-tool/content.md": "b070",
	"./extending-acorns/content.md": "b364",
	"./field-monitoring-plans/content.md": "30c5",
	"./map-tool/content.md": "541f",
	"./model-gui/content.md": "8612",
	"./ouzel-background/content.md": "6aa3",
	"./ouzel-contacts/content.md": "203a",
	"./ouzel-issues/content.md": "d70b",
	"./ouzel-overview/content.md": "0cb0",
	"./ouzel-projects/content.md": "865d",
	"./r-code/content.md": "2315",
	"./spatial-data-management/content.md": "2793",
	"./teaching-r/content.md": "b388",
	"./unit-testing/content.md": "bac1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33a8";